module.exports = __webpack_public_path__ + "static/media/Receipt-orange.0f99b81b.svg";